import { useDispatch, useSelector } from 'react-redux';
import { Input } from '@cdl/heartbeat-react';
import {
  setActiveTasksPage,
  setInactiveTasksPage,
  handleParams,
} from '../../../actions/admin.actions';
import {
  endDateParamsSelector,
  startDateParamsSelector,
} from '../../../selectors/admin.selectors';

export const DateRangeFilter = () => {
  const startDate = useSelector(startDateParamsSelector);
  const endDate = useSelector(endDateParamsSelector);
  const dispatch = useDispatch();

  const handleStartDateChange = (updates: string) => {
    dispatch(handleParams({ param: 'startDate', value: updates }));
    dispatch(setActiveTasksPage({ page: 1 }));
    dispatch(setInactiveTasksPage({ page: 1 }));
  };

  const handleEndDateChange = (updates: string) => {
    dispatch(handleParams({ param: 'endDate', value: updates }));
    dispatch(setActiveTasksPage({ page: 1 }));
    dispatch(setInactiveTasksPage({ page: 1 }));
  };

  return (
    <>
      <Input
        minWidth='40'
        type='date'
        onChange={(e) => handleStartDateChange(e.target.value)}
        value={startDate}
      />
      <Input
        minWidth='40'
        type='date'
        onChange={(e) => handleEndDateChange(e.target.value)}
        value={endDate}
      />
    </>
  );
};
